export enum GQLQueries {
  Nfts = 'Nfts',
  NFTItemScreen = 'NFTItemScreen',
  NftCollectionScreen = 'NftCollectionScreen',
  NftsTab = 'NftsTab',
  PortfolioBalances = 'PortfolioBalances',
  SelectWalletScreen = 'SelectWalletScreen',
  TransactionHistoryUpdater = 'TransactionHistoryUpdater',
  Token = 'Token',
  TokenDetailsScreen = 'TokenDetailsScreen',
  TokenPriceHistory = 'TokenPriceHistory',
  TokenProjects = 'TokenProjects',
  TransactionList = 'TransactionList',
  TopTokens = 'TopTokens',
  SearchTokens = 'SearchTokens',
  ExploreSearch = 'ExploreSearch',
  SpotPrices = 'SpotPrices',
  ExploreTokensTab = 'ExploreTokensTab',
  FavoriteTokenCard = 'FavoriteTokenCard',
}
